// Admin API client. Base URL can be overridden via REACT_APP_API_URL.
// e.g. REACT_APP_API_URL=http://localhost:5001/api npm start
export const API_URL =
  process.env.REACT_APP_API_URL || "https://thesparksync.com/api";

export function getToken() {
  return localStorage.getItem("admin_token");
}
export function setToken(t) {
  if (t) localStorage.setItem("admin_token", t);
  else localStorage.removeItem("admin_token");
}

async function request(method, path, body) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (body !== undefined) headers["Content-Type"] = "application/json";

  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let json = {};
  try {
    json = await res.json();
  } catch (e) {
    /* ignore */
  }
  // An expired/invalid session logs out; a failed login just shows its error.
  if (res.status === 401 && token && path !== "/admin/login") {
    setToken(null);
    window.location.reload();
  }
  if (!res.ok || json.success === false) {
    throw new Error(json.message || `Request failed (${res.status})`);
  }
  return json.data;
}

const api = {
  get: (p) => request("GET", p),
  post: (p, b) => request("POST", p, b),
  patch: (p, b) => request("PATCH", p, b),
  del: (p) => request("DELETE", p),
};

export default api;
